import styled from "@emotion/styled";
import { Flex } from "@otrium/core";
import { Button } from "src/atoms/Button";

const StyledAddToCollection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 320px;
  max-width: 600px;
  max-height: 800px;
  min-height: 164px;
  background: ${({ theme }) => theme.colors.tone.white};
  padding: ${({ theme }) => theme.space.space24};
  position: relative;
`;

const StyledInfoHeader = styled(Flex)`
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  color: ${({ theme }) => theme.colors.tone.anthraciteDark};
  letter-spacing: 0.2em;
`;

const StyledButton = styled(Button)`
  background: yellow;
`;

export { StyledAddToCollection, StyledInfoHeader, StyledButton };
